export const GITHUB_INTEGRATION = {
  TITLE: 'Connect your GitHub organization',
  STEP1: {
    DESCRIPTION: 'Enter your GitHub organization login to begin the connection process.',
    INPUT_LABEL: 'GitHub organization login',
    INPUT_HELP_LINK: 'How do I access my organization?',
    INPUT_ERROR: 'Please enter your organization login',
    PERMISSIONS_DISCLAIMER: 'Account must have organization owner or admin privileges.',
  },
  STEP2: {
    DESCRIPTION: "Verify the organization. You'll be redirected to GitHub to install the Qalea app.",
    ADDITIONAL_INFO: 'The app must be installed here. Check the',
    ADDITIONAL_INFO_LINK: 'integration guide',
    ADDITIONAL_INFO_SUFFIX: 'for more details.',
  },
  FOOTER: {
    CANCEL: 'Cancel',
    CONTINUE: 'Continue',
    BACK: 'Back',
    OPEN_EXTERNAL: 'Open GitHub',
  },
  STEP_PROGRESS: {
    STEP_1: 'Step 1: Organization Details',
    STEP_2: 'Step 2: Review & Install',
  },
}
